import React, { useEffect, useState } from "react";
import LineBox from "../../../../DefaultStyles/LineBox";
import Table, { TableBody, TableBodyItem } from "../../../../Table/Table";
import MatchMakingEmailFilter, {
  matchMakingEmailFilter,
} from "./components/MatchMakingEmailFilter";
import LineBtn from "../../../../Button/LineBtn";
import MatchMakingEmailInfoModal from "./components/MatchMakingEmailInfoModal";

import { useApi } from "../../../../../hooks/useApi";
import { useRecoilState, useRecoilValue } from "recoil";
import { authType } from "../../../../../pages/Login";
import { toast } from "react-toastify";
import SpaceBetween from "../../../../DefaultStyles/SpaceBetween";
import Pagination from "../../../../Table/Pagination";
import { TotalCount } from "../../../../../pages/Users/UserInfo";
import { decryptPW, getThousandComma } from "../../../../../Api/ApiCommon";
import Loader from "../../../../DefaultStyles/Loader";
import { useNavigate } from "react-router-dom";
import PartyMailModal from "../../PartyDetail/PartyDetailShareInfo/PartyMailModal";
import {
  getString3ByKey,
  getSubsNameBySubsId3,
} from "../../../../../AdminApi/3.0_utils";
import {
  GetServiceSetData_V3,
  GetSubscriptionSetData_V3,
} from "../../../../../ApiTS/ServiceDatasTS_V3";

export interface IMatchPartyEmail {
  id: number;
  email: string;
  comment?: string;
  partyid?: number[];
  password?: string;
  servsubsid: number;
}

export default function MatchMakingEmail() {
  const auth = useRecoilValue(authType);
  const navigate = useNavigate();

  const [filter, setFilter] = useRecoilState(matchMakingEmailFilter);
  const [page, setPage] = useState(filter?.page ?? 0);

  useEffect(() => {
    setFilter((prev) => ({ ...prev, page: 0 }));
  }, []);

  const [emailInfoModal, setEmailInfoModal] = useState<{
    modal: boolean;
    data?: IMatchPartyEmail;
  }>({
    modal: false,
    data: undefined,
  });
  const [linkidMailModal, setLinkidMailModal] = useState({
    modal: false,
    email: "",
  });

  const { response, loading, error, fetchData } = useApi({
    method: "get",
    url: auth?.adminSet
      ? `matchParty/email?page=${page}&size=10` +
        (filter?.searchValue !== "" ? `&email=${filter?.searchValue}` : ``) +
        (filter?.searchComment !== "" ? `&comment=${filter?.searchComment}` : "") +
        (filter?.subsId !== "" ? `&servsubsid=${filter?.subsId}` : ``) +
        (filter?.using !== "" && filter?.using !== "all"
          ? `&isUsing=${filter?.using}`
          : ``)
      : undefined,
  });

  const tableHead = [
    "No",
    "Subscription",
    "계정 이름",
    "이메일",
    "비밀번호",
    "사용 중인 파티",
    "코멘트",
    "계정 관리",
  ];

  useEffect(() => {
    if (error) {
      toast.error(
        error?.data ?? "이메일 리스트를 가져오는 데에 실패하였습니다."
      );
    }
  }, [error]);

  return (
    <>
      <MatchMakingEmailFilter
        refetch={() =>
          fetchData({
            method: "get",
            url: auth?.adminSet
              ? `matchParty/email?page=${page}&size=10`
              : undefined,
          })
        }
      />

      <LineBox>
        <Table tableHeadData={tableHead}>
          <>
            {response?.data?.items?.map((d: IMatchPartyEmail) => {
              const subsData = GetSubscriptionSetData_V3(d?.servsubsid ?? 0);
              const svcData = GetServiceSetData_V3(subsData?.SVC_ID ?? 0);

              return (
                <TableBody key={d?.id}>
                  <TableBodyItem>{d?.id}</TableBodyItem>
                  <TableBodyItem isKeepAll={true}>
                    {d?.servsubsid
                      ? getSubsNameBySubsId3(d?.servsubsid) ?? "-"
                      : "-"}
                  </TableBodyItem>
                  <TableBodyItem>
                    {getString3ByKey(Number(svcData?.SVC_NM))}_{d?.id}
                  </TableBodyItem>
                  <TableBodyItem
                    clickable={true}
                    onClick={() =>
                      setLinkidMailModal({
                        modal: true,
                        email: d?.email,
                      })
                    }
                  >
                    {d?.email}
                  </TableBodyItem>
                  <TableBodyItem>
                    {d?.password
                      ? decryptPW(
                          d?.password,
                          subsData?.SVC_ID === 3100 ? 3 : 1
                        )?.pw
                      : "-"}
                  </TableBodyItem>
                  <TableBodyItem isKeepAll={true}>
                    {d?.partyid
                      ? d?.partyid?.map((p, i) => (
                          <>
                            <span
                              key={p}
                              onClick={() => {
                              setFilter((prev) => ({ ...prev, page }));
                              navigate(`/party/info/${p}`);
                            }}
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                            >
                              {p}
                            </span>

                            {i !== d?.partyid?.length! - 1 && <>{", "}</>}
                          </>
                        ))
                      : "-"}
                  </TableBodyItem>
                  <TableBodyItem isKeepAll={true}>
                    {d?.comment ?? "-"}
                  </TableBodyItem>
                  <TableBodyItem>
                    <LineBtn
                      btnText="수정하기"
                      disabled={d?.partyid && d?.partyid?.length > 0}
                      btnClickEvent={() =>
                        setEmailInfoModal({
                          modal: true,
                          data: d,
                        })
                      }
                    />
                  </TableBodyItem>
                </TableBody>
              );
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      {loading && <Loader />}

      {emailInfoModal.modal && (
        <MatchMakingEmailInfoModal
          closeEvent={() =>
            setEmailInfoModal({
              modal: false,
              data: undefined,
            })
          }
          data={emailInfoModal.data}
          refetch={() =>
            fetchData({
              method: "get",
              url: auth?.adminSet
                ? `matchParty/email?page=${page}&size=10`
                : undefined,
            })
          }
        />
      )}

      {linkidMailModal.modal && (
        <PartyMailModal
          closeEvent={() =>
            setLinkidMailModal({
              modal: false,
              email: "",
            })
          }
          mailId={linkidMailModal.email}
          type={
            linkidMailModal.email?.includes("testgrove.pw") ||
            linkidMailModal.email?.includes("linkidmail.com")
              ? "db"
              : "mailgun"
          }
        />
      )}
    </>
  );
}
